<template>
    <v-card>
        <v-card-title>
            <span class="headline">Logs pedido: {{ $_str_pad_left(pedidoId) }}</span>
        </v-card-title>
        <v-card-text>
            <v-timeline dense>
                <v-slide-x-reverse-transition
                    group
                    hide-on-leave
                >
                    <v-timeline-item
                        v-for="item in logs"
                        :key="item.created_at"
                        :color="item.estatus_color"
                        small
                        fill-dot
                    >
                        <v-alert
                            :value="true"
                            :icon="item.estatus_icon"
                            :color="item.estatus_color"
                        >
                            {{ item.email }}<br>
                            {{ item.estatus_nombre }} :: {{ formatFecha(item.created_at) }}
                        </v-alert>
                    </v-timeline-item>
                </v-slide-x-reverse-transition>
            </v-timeline>
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="$emit('form:close')"
            >
                Cerrar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    import moment from 'moment';

    moment.locale('es');

    export default {
        name: "LogPedido",
        props: {
            logs: {
                type: Array,
                default: () => []
            },
            pedidoId: {
                type: Number,
                default: 0
            }
        },
        methods: {
            formatFecha(fecha) {
                let fecha_moment = moment.unix(fecha);
                return fecha_moment.format('MMMM Do YYYY, h:mm:ss a');
            }
        }
    }
</script>

<style scoped>

</style>
